/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import { apiFetch } from '../../../apiClient';
import { apiMap } from '../../../config/constants';
import { getMessage } from '../../../shared/containers/IntlProvider/state/actions';
import * as action from '../state/action';
import BasePage from '../../../shared/BasePage';
import Help from '../components/Help';
import { setTitle } from '../../../utils';

class HelpContainer extends BasePage {

    loadContentMessage = () => {
        this.fetchData();
    }

    componentDidMount = () => {
        this.fetchData();
    }

    fetchData = () => {
        apiFetch(apiMap.help, {})().then( i18n => {
            this.props.getHelpMessage({
                i18n
            });
        }).catch(error => {});
    }
    
    render() {
        const { i18n, pageTitle } = this.props;

        if (i18n && pageTitle) {
          setTitle( i18n.title + pageTitle);
        }

        return !!i18n ? (
            <div>                
                <Help i18n={i18n}/>
            </div>
        ) : null
    }
}

HelpContainer.propTypes = {
    i18n: PropTypes.object,
    selectedLanguage: PropTypes.string
};

const mapStateToProps = (state) => ({
    i18n: state.help.i18n,
    selectedLanguage: state.app.selectedLanguage,
    getMessage,
    pageTitle: state.app.i18n.pageTitle
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(action, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HelpContainer);


// WEBPACK FOOTER //
// ./src/views/Help/container/Help.js